import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { IRouter } from '../../interfaces/router.interface';

@Component({
  selector: 'app-create-dropdown',
  templateUrl: './create-dropdown.component.html',
  styleUrls: ['./create-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateDropdownComponent implements OnInit {
  @Input() createActions: List<List<IRouter>>;

  @Output() onSelectAction: EventEmitter<IRouter> = new EventEmitter<IRouter>();

  constructor() {}

  ngOnInit() {}
}
